import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    }
  },
  getters: {
    get: (state, getters, rootState) => (id) => {
      return state.items.find((item) => item.id === id)
    },
    getName: (state, getters, rootState) => (id) => {
      const lang = rootState.lang
      const item = state.items.find((item) => item.id === id)
      if (item) {
        return item.translations && item.translations[lang] ? item.translations[lang] : item.name
      } else {
        return false
      }
    }
  },
  actions: {
    get ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getThematicCategories(token)
            .then((res) => {
              commit('setItems', res.body.list)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
